function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef, useState } from 'react';
import { sendAnalytics } from '@audio-network/analytics';
import * as Styled from './Waveform.styles';
import { formatTime, formatTrackNumber } from '../../utils';
import { usePlayer, usePlayerAudio } from '../../hooks';
var Waveform = function Waveform() {
  var _currentTrack$wavefor, _currentTrack$wavefor2;
  var _usePlayer = usePlayer(),
    currentTrack = _usePlayer.currentTrack,
    playNextTrack = _usePlayer.playNextTrack;
  var _usePlayerAudio = usePlayerAudio(),
    audioElement = _usePlayerAudio.audioElement,
    setCurrentTime = _usePlayerAudio.setCurrentTime;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    baseTrackUrl = _useState2[0],
    setBaseTrackUrl = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    playbackTime = _useState4[0],
    setPlaybackTime = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    trackDuration = _useState6[0],
    setTrackDuration = _useState6[1];
  var _useState7 = useState('0'),
    _useState8 = _slicedToArray(_useState7, 2),
    scrubberTime = _useState8[0],
    setScrubberTime = _useState8[1];
  var waveformRef = useRef(null);
  useEffect(function () {
    if (currentTrack) {
      var _currentTrack$album, _currentTrack$album2;
      setPlaybackTime('0:00');
      if (!waveformRef.current) return;
      waveformRef.current.style.clipPath = 'inset(0 100% 0 0)';
      setBaseTrackUrl("https://content2.audionetwork.com/Preview/tracks/mp3/v5res/ANW".concat(((_currentTrack$album = currentTrack.album) === null || _currentTrack$album === void 0 ? void 0 : _currentTrack$album.number) || ((_currentTrack$album2 = currentTrack.album) === null || _currentTrack$album2 === void 0 ? void 0 : _currentTrack$album2.id), "/").concat(formatTrackNumber(currentTrack.albumTrackNumber)));
    }
  }, [JSON.stringify(currentTrack)]);
  var updateWaveform = function updateWaveform() {
    var duration = audioElement.duration,
      currentTime = audioElement.currentTime;
    setScrubberTime(currentTime.toString());
    setPlaybackTime(formatTime(currentTime));
    var percentageComplete = 100 / duration * currentTime;
    var progressWidth = 100 - percentageComplete;
    if (!waveformRef.current) return;
    waveformRef.current.style.clipPath = "inset(0px ".concat(progressWidth, "% 0px 0px)");
  };
  var handleAnalytics = function handleAnalytics() {
    sendAnalytics(null, 'Player', 'Waveform Clicked');
  };
  var handleKeydown = function handleKeydown(event) {
    var code = event.code;

    /**
     * Override native controls
     * with preferred skipping step
     */
    switch (code) {
      case 'Space':
        event.target.blur();
        break;
      default:
        break;
    }
    handleAnalytics();
  };
  useEffect(function () {
    if (audioElement) {
      audioElement.addEventListener('timeupdate', function () {
        return updateWaveform();
      });
      audioElement.addEventListener('durationchange', function () {
        return setTrackDuration(audioElement.duration);
      });
      audioElement.addEventListener('ended', playNextTrack);
    }
  }, [JSON.stringify(audioElement)]);
  var isSoundEffect = (currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.type) === 'sound-effect';
  var backgroundSrc = (_currentTrack$wavefor = currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.waveformImageUrl) !== null && _currentTrack$wavefor !== void 0 ? _currentTrack$wavefor : baseTrackUrl ? "".concat(baseTrackUrl, "_g.png") : '';
  var playbackSrc = (_currentTrack$wavefor2 = currentTrack === null || currentTrack === void 0 ? void 0 : currentTrack.waveformImageUrl) !== null && _currentTrack$wavefor2 !== void 0 ? _currentTrack$wavefor2 : baseTrackUrl ? "".concat(baseTrackUrl, "_y.png") : '';
  return /*#__PURE__*/React.createElement(Styled.WaveformContainer, null, currentTrack && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.Time, {
    variant: "bodyS"
  }, playbackTime), /*#__PURE__*/React.createElement(Styled.Waveform, null, /*#__PURE__*/React.createElement(Styled.WaveWrapper, {
    isSoundEffect: isSoundEffect
  }, baseTrackUrl && /*#__PURE__*/React.createElement(Styled.WaveformImage, {
    alt: "",
    src: backgroundSrc
  })), /*#__PURE__*/React.createElement(Styled.PlaybackWaveWrapper, {
    ref: waveformRef,
    isSoundEffect: isSoundEffect
  }, baseTrackUrl && /*#__PURE__*/React.createElement(Styled.WaveformImage, {
    alt: "",
    src: playbackSrc
  })), /*#__PURE__*/React.createElement(Styled.Slider, {
    maxValue: trackDuration.toString(),
    onInput: setCurrentTime,
    "data-testid": "player-track-scrubber",
    name: "player-scrubber",
    value: scrubberTime,
    noInteraction: true,
    onMouseUp: handleAnalytics,
    onKeyDown: handleKeydown,
    step: 1
  })), /*#__PURE__*/React.createElement(Styled.Duration, {
    variant: "bodyS",
    "data-testid": "player-track-duration"
  }, formatTime(trackDuration))));
};
export default Waveform;